/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map, List, fromJS } from 'immutable';
import { RestAPI } from '@/util/net';
import { putError } from '@/store/error.store';


export const notificationReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'NOTIFICATIONS_LOADED':
      return state.set('notifications', fromJS(action.data));
    case 'NOTIFICATIONS_MARKED':
      return state.set('notifications', state.get('notifications').map(n => n.set('read', true)));
    case 'NOTIFICATIONS_MARKED_GROUP':
      return state.set('notifications', state.get('notifications').map(n => {
        if (action.ids.includes(n.get('id'))) {
          return n.set('read', true);
        }
        return n;
      }));
    case 'WS_NOTIFICATION_RECEIVED':
      return state.set('notifications', List.of(fromJS(action.data).set('ws', true))
        .concat(state.get('notifications', new List())));
    default:
      return state;
  }
};

export const fetchUserNotifications = (dispatch) => {
  dispatch({ type: 'FETCH_USER_NOTIFICATIONS_STARTED' });
  return RestAPI.get('/information/api')
    .then(
      (data) => {
        dispatch({ type: 'NOTIFICATIONS_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'FETCHING_NOTIFICATIONS_FAILED' });
        return true;
      },
    );
};

export const notificationMarkReadAll = (dispatch) => {
  dispatch({ type: 'NOTIFICATION_MARK_READ_ALL_STARTED' });
  return RestAPI.get('/information/api/read')
    .then(
      () => {
        dispatch({ type: 'NOTIFICATIONS_MARKED' });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'NOTIFICATION_MARK_READ_ALL_FAILED' });
        return true;
      },
    );
};

export const notificationMarkRead = (dispatch, ids) => {
  dispatch({ type: 'NOTIFICATION_MARK_READ_GROUP_STARTED' });
  return RestAPI.get(`/information/api/read?ids=${ids}`)
    .then(
      () => {
        dispatch({ type: 'NOTIFICATIONS_MARKED_GROUP', ids });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'NOTIFICATION_MARK_READ_GROUP_FAILED' });
        return true;
      },
    );
};
